import { render, staticRenderFns } from "./UserGroupManagement.vue?vue&type=template&id=468f6936"
import script from "./UserGroupManagement.vue?vue&type=script&lang=ts"
export * from "./UserGroupManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports